/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_AddInputs */



/**
* | output |
* | --- |
* | "Add Player" |
*
* @param {Players_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_add = /** @type {((inputs?: Players_AddInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_AddInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar Jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi Giocatore")
	return /** @type {LocalizedString} */ ("Add Player")
});